import { createGlobalStyle } from "styled-components";
import styled from "styled-components";
export const ProjectModalStyle = createGlobalStyle`
.project-transfer {
  .ant-transfer-list {
    border: unset;
    width: 220px;
  }
  .ant-transfer-list-body {
    border-radius: 3px;
    height: 330px;
    overflow: hidden auto;
    background-color: rgb(44, 44, 49);
  }

  .ant-transfer-list-header {
    border: unset;
    width: 220px;
    height: 26px;
    background: #27282c;
    color: rgba(140, 146, 148, 0.85);
    line-height: 22px;
  }

  .ant-transfer-list-header-selected {
    display: none;
  }

  .ant-transfer-list-header-title {
    text-align: center;
  }

  .ant-transfer-list-content {
    background-color: #2c2c31;
  }
  .ant-transfer-operation {
    margin: 0 30px;
  }
  .ant-transfer-list-content-item {
    &:hover {
      background-color: #222227;
    }
  }
  .ant-transfer-list-content-item-remove:hover {
    color: #f5533c;
  }
  .ant-checkbox-wrapper.ant-transfer-list-checkbox {
    display: none;
  }
  .ant-transfer-list-content {
    height: 330px;
  }
  .ant-transfer-list {
    height: unset;
  }
  .ant-transfer-operation button {
    background-color: unset;
    border: unset;
    color: #666;
    &:hover {
      background-color: unset;
      color: #666;
      cursor: pointer;
    }
  }
  .transfer-item {
    display: flex;
    justify-content: space-between;
  }
}
.params-locked-tip {
  color: rgba(140, 146, 148, 0.85);
}
.checkBox-item {
  display: flex;
  flex-wrap: nowrap;
  height: 30px;
  line-height: 30px;
  margin-top: 14px;
  .ant-input-number {
    width: 100px;
    height: 30px;
    margin: 0 12px 0 10px;
  }
  .ant-slider {
    width: 207px;
  }
  .ant-checkbox + span {
    width: 140px;
    line-height: 18px;
  }
}
.project-transfer-select  {
  .ant-select-selector {
    background-color: #2c2c31 !important;
    font-size: 12px !important;
    width: 120px !important;
  }
  min-width: 120px !important;
  margin-left: 34px;
}
.project-popup-select {
  background-color: #2c2c31;
  padding: 0;
  border-radius: 0;
  .ant-select-item-option {
    border-radius: 0;
    font-size: 12px;
    &-active:not(.ant-select-item-option-disabled),
    &-selected:not(.ant-select-item-option-disabled) {
      background: var(--main-color) !important;
    }
  }
}
.child-manage-tree-container {
  display: flex;
  align-items: center;
  justify-content: stretch;
  .tree-operate {
    display: none;
  }
  &:hover {
    .tree-operate {
      display: initial;
    }
  }
}
.child-manage-leader {
  border: 1px solid var(--main-color);
  color: var(--main-color);
  border-radius: 2px;
  margin-left: 10px;
  padding: 0 8px;

}

`;

export const DrawerFooter = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  gap: 16px;
  .renderbus-ui--button {
    width: 136px;
    height: 40px;
    font-size: 14px;
    color: #fff;
    text-align: center;
  }
`;
